import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './style.scss';

const env = process.env.TIGER_BUILD_ENV;
const domain = (env === 'test' ? 'https://ext-innerapi-webtest.huya.com/' :'https://ext-innerapi.huya.com/');

const Axios = () => {

  const [appId, setAppId] = useState('');
  const [secret, setSecret] = useState('');
  const [jwtToken, setJwtToken] = useState('');

  const [roomId, setRoomId] = useState('');
  const [iat, setIat] = useState('');
  const [exp, setExp] = useState('');

  

  const [tokenHeader, setTokenHeader] = useState('');
  const [tokenPayload, setTokenPayload] = useState('');
   
  const [isLoading, setIsLoading] = useState(false);

  const [genMsg, setGenMsg] = useState('');
  
  const handlGenToken = async () => {
    setIsLoading(true);
    setGenMsg('');
    setJwtToken('');
    try {
      // 发起GET请求
      await axios.get( domain +'api/jwt/genToken?appId='+appId+'&secret='+secret)
        .then(responseData => {
          if (responseData.status === 200) {
            if(responseData.data.status === 0) {
              setJwtToken(responseData.data.data);

              handleParseToken(responseData.data.data);


            } else {
              setGenMsg('预览失败:' + responseData.data.msg);
            }
          } else {
            setGenMsg('请求失败，错误信息：'+ responseData.msg);
          }
        })
    } catch (error) {
      setGenMsg('请求失败，错误信息：'+error.msg);
    }
    setIsLoading(false);
  };

  const changeAppId = (event) => {
    setAppId(event.target.value);
  };

  const changeSecret = (event) => {
    setSecret(event.target.value);
  };
  const   changeRoomId  = (event) => {
    setRoomId(event.target.value);
  };
  

  const handleParseToken = async (token) => {
    setTokenHeader('');
    setTokenPayload('');
    setIat('');
    setExp('');
    try {
      // 发起GET请求
      axios.get( domain +'api/jwt/parseToken?token='+token)
      .then(responseData => {
        if (responseData.status === 200) {
          if(responseData.data.status === 0) {
            setTokenHeader(responseData.data.data.tokenHeader);
            setTokenPayload(responseData.data.data.tokenPayload);
            const obj = JSON.parse(responseData.data.data.tokenPayload);
            setExp(obj.exp);
            setIat(obj.iat);
          } else {
            setGenMsg('解析失败:' + responseData.data.msg);
          }
        } else {
          setGenMsg('请求失败，错误信息：'+ responseData.msg);
        }
      })
    } catch (error) {
      // 输出错误信息
      setGenMsg.log('请求失败，错误信息：', error.message);
    }
  };

  return (
    <div>
      <div>
          <h3>JWT在线预览</h3>
          <div className="input-body">
            AppId：
          </div>
          <div className="input-body">
            JWT预览结果：
          </div>

          <div className="input-body">
            <input type="text" className="token-input" value={appId} onChange={changeAppId} placeholder="请输入AppId"/>
          </div>

          <div className="token-body">
            <textarea  className="token-textarea" rows = {6} value={jwtToken} disabled />
          </div>


          <div className="input-left">
            Secret：
          </div>

          <div className="secret-input-body">
            <input type="text" className="token-input-left" value={secret} onChange={changeSecret} placeholder="请输入Secret"/>
              <div className="input-room">
                RoomId(WS链接预览使用)：
              </div>
              <div className="secret-input-body">
                <input type="text" className="token-input-room" value={roomId} onChange={changeRoomId} placeholder="请输入RoomId"/>
                <br />
                <div className="btn-body">
                  <button onClick={handlGenToken} disabled={isLoading} className='btn'>
                    {isLoading ? '预览中...' : '点击预览'}
                  </button>
                  <span>
                    <font className="error-msg" >{genMsg}</font>
                  </span>
              </div>
            </div>  
          </div>  

          <div className='parse-content-body'>
              <p className="text-line-header">Header:<span>描述 JWT 的元数据</span></p>
              <textarea  className="parse-content-textarea" rows = {3} value={tokenHeader} disabled/>

              <p className="text-line">Payload:<span>存放实际需要传递的数据</span></p>
              <textarea  className="parse-content-textarea" rows = {3} value={tokenPayload} disabled/>
          </div>
      </div>

      <div className='ws-body' >
        <span className='keyword-desc'>
        WS链接预览：
        </span>
        <br />
        <br />
        {/* <span className="keyword-first">var </span>
        <span>socket </span>
        <span className="oper">=</span>
        <span className="keyword"> new </span>
        <span className="class-name">WebSocket</span>
        <span className="punctuation">(</span> */}
        <span className="string ">ws://ws-apiext.huya.com/index.html?do=comm&amp;roomId={roomId}&amp;appId={appId}&amp;iat={iat}&amp;exp={exp}&amp;sToken={jwtToken}</span>
        {/* <span className="punctuation">);</span> */}
        <span className="punctuation"><br /></span>
        <br />
      </div>
      
      <br />
    </div>
  )
}

export default Axios;
